<template>
    <x-form ref="additionalInformationForm" @submit.prevent="submit">
        <x-container fluid>
            <x-layout class="question-set">
                <x-flex xs2 offset-xs1>
                    <h3 class="question-set-title">Additional Information <span v-if="!this.submission.product_data.prior_experience" class="question-set-subtitle">(optional)</span></h3>
                </x-flex>

                <x-flex xs6 class="question-set-questions">
                    <additional-information-edit
                        v-model="submission.information_sections"
                        :facility-id="submission.facility_id"
                    />
                </x-flex>
            </x-layout>

            <x-layout class="action-set" align-center>
                <x-flex xs6 offset-xs3 class="action-set-actions">
                    <x-container>
                        <x-layout>
                            <x-flex xs6>
                                <x-btn
                                    v-if="submission.id > 0"
                                    class="mr-4"
                                    color="tertiary"
                                    @click="$emit('submission:navigate-to', currentStep - 1)"
                                >
                                    <i class="material-icons mr-2">arrow_back</i>

                                    Back
                                </x-btn>

                                <x-btn
                                    v-else
                                    class="mr-4"
                                    color="tertiary"
                                    @click="$emit('submission:cancel')"
                                >
                                    <i class="material-icons mr-2">arrow_back</i>

                                    Cancel
                                </x-btn>

                                <delete-quote-button v-if="submission.status === 'draft'" :submissionId="submission.id" />
                            </x-flex>

                            <x-flex xs6 text-xs-right>
                                <x-btn
                                    class="wide"
                                    type="submit"
                                    color="primary"
                                    data-test="next"
                                >
                                    Next

                                    <i class="material-icons ml-2">trending_flat</i>
                                </x-btn>
                            </x-flex>
                        </x-layout>
                    </x-container>
                </x-flex>
            </x-layout>
        </x-container>

        <modal
            ref="additionalInformationModal"
            title="Something went wrong"
            actionText="Ok"
            contentClass="error-message-window"
        >
            <ul class="error--text">
                At least 1 prior experience section is required when prior experience is Yes.
            </ul>
        </modal>
    </x-form>
</template>

<script>
    import AdditionalInformationEdit from '~/components/Broker/UIComponents/AdditionalInformationEdit';
    import Modal from '~/components/Shared/UIComponents/Modal';
    import DeleteQuoteButton from '~/components/Broker/UIComponents/DeleteQuoteButton';

    export default {
        name: 'AdditionalInformation',
        components: {
            AdditionalInformationEdit,
            Modal,
            DeleteQuoteButton,
        },
        props: {
            value: Object,
            currentStep: Number,
        },
        data() {
            return {
                sectionNames: [
                    'Interest',
                    'Premium',
                    'Prior experience',
                    'Other'
                ],
                blankSection: {
                    selected_name: null,
                    name: null,
                    insurer_company_ids: [],
                    content: null
                },
                insurers: [],
                nextKey: 1
            }
        },
        computed: {
            submission: {
                get() {
                    return this.value;
                },
                set(submission) {
                    this.$emit('input', submission);
                }
            }
        },
        watch: {
            value: {
                handler() {
                    this.$emit('input', this.value);
                },
                deep: true
            }
        },
        methods: {
            submit() {
                if (!this.isPriorExperienceValid()) {
                    this.$refs.additionalInformationModal.open();

                    return;
                }

                if (this.$refs.additionalInformationForm.validate()) {
                    this.$emit('submission:save', this.currentStep);
                }
            },
            isPriorExperienceValid() {
                if (!this.submission.product_data.prior_experience) {
                    return true;
                }

                if (this.submission.information_sections.length < 1) {
                    return false;
                }

                const priorExperienceSection = this.submission.information_sections.find(section => section.name === 'Prior experience') || null;

                return Boolean(priorExperienceSection);
            }
        }
    }
</script>
